<template>
  <div>
    <v-hover v-slot="{ isHovering, props }" v-if="item.estatus">
      <v-card
        class="mx-auto"
        color="grey-lighten-4"
        max-width="300"
        height="350"
        v-bind="props"
      >
        <v-img
          :aspect-ratio="16 / 9"
          src="https://th.bing.com/th/id/R.34cbeaed7ea905eef6b8c778b54e3d88?rik=th4nsmp4V4%2b3bQ&riu=http%3a%2f%2fcwsourcing.com%2fwp-content%2fuploads%2f2015%2f12%2f15_Herramientas.jpg&ehk=pAx3yVYhBcoAn3DNzf7pcaI1M1PFvj2qlXSGQE1K4Ng%3d&risl=&pid=ImgRaw&r=0"
          cover
        >
          <v-expand-transition>
            <div
              v-if="isHovering"
              class="d-flex transition-fast-in-fast-out bg-orange-darken-2 v-card--reveal text-h2"
              style="height: 100%"
            >
              ${{ item.precio2 }}
            </div>
          </v-expand-transition>
        </v-img>

        <v-card-text>
          <p
            style="
              font-family: Arial, Helvetica, sans-serif;
              font-size: medium;
              font-weight: 400;
              color: orange;
            "
          >
            {{ CategoriaTruncado }}
          </p>

          <p
            class="limited-text"
            style="
              font-family: Arial, Helvetica, sans-serif;
              font-size: medium;
              font-weight: 500;
              color: black;
            "
          >
            {{ DescripcionTruncado }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-dialog transition="dialog-bottom-transition" width="auto">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn
                v-bind="activatorProps"
                text="Cotizar"
                color="blue"
                variant="outlined"
                block
              ></v-btn>
            </template>

            <template v-slot:default="{ isActive }">
              <v-card>
                <v-toolbar
                  style="background-color: green; color: white"
                  align="center"
                  title="INFORMACIÓN"
                >
                <v-btn icon dark @click="isActive.value = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
              </v-toolbar>

                <v-progress-linear
                  color="cyan"
                  :indeterminate="loading"
                ></v-progress-linear>


                <alert-component
                  v-if="resultado1"
                  :tipo="'success'"
                  :titulo="'Aviso'"
                  :descripcion="'Listo!!, Ya esta en tu carrito'"
                />
                <alert-component
                  v-if="resultado2"
                  :tipo="'error'"
                  :titulo="'Aviso'"
                  :descripcion="'Ups!!, Ocurrio un problema al intentar agregarlo al carrito'"
                />
                <v-btn variant="outlined" prepend-icon="mdi-cart" to="/carrito" block>
            Ir al carrito
          </v-btn>
                <v-card-text
                  align="center"
                  style="
                    font-family: Arial, Helvetica, sans-serif;
                    font-size: medium;
                    font-weight: 500;
                  "
                >
                  <p>{{ item.descripcion }}</p>
                  <p>CATEGORIA: {{ item.categoria }}</p>
                  <p>
                    PRECIO: $
                    <span style="color: green; font-weight: 600"
                      >{{ item.precio2 }} MXN</span
                    >
                  </p>
                </v-card-text>
                <div class="quantity-controls">
                  <button class="quantity-decrease" @click="RestarCantidad">
                    -
                  </button>
                  <input
                    type="text"
                    class="quantity-input"
                    v-model="cantidad"
                  />
                  <button class="quantity-increase" @click="SumarCantidad">
                    +
                  </button>
                </div>

                <v-card-actions class="justify-center" style="margin-top: 10px">
                  <v-btn
                    block
                    variant="outlined"
                    color="success"
                    @click="AgregarAlCarro()"
                    >Agregar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-hover>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AlertComponent from './AlertComponent.vue';

export default {
  props: {
    item: {
      codigo: {
      type:String,
      default:''
    },
      descripcion: {
      type:String,
      default:''
    },
      precio1: {
      type:String,
      default:0
    },
      precio2: {
      type:String,
      default:0
    },
      clasificacion: {
      type:String,
      default:''
    },
      claveClasificacion: {
      type:String,
      default:''
    },
      estatus: {
      type:String,
      default:0
    },
    },
  },
  data() {
    return {
      cantidad: 0,
      loading: false,
      resultado1: false,
      resultado2: false,
    };
  },
  components: {
    AlertComponent,
  },

  methods: {
    ...mapActions('cartProduct', ['addToCartProduct']),

    SumarCantidad() {
      this.cantidad++;
    },
    RestarCantidad() {
      this.cantidad--;
    },

    AgregarAlCarro() {
      try {
        this.loading = true;
      
        var newProduct = {
          codigo: this.item.codigo,
          descripcion: this.item.descripcion,
          precio1: this.item.precio1,
          precio2: this.item.precio2,
          clasificacion: this.item.clasificacion,
          claveClasifica: this.item.clasificacion,
          cantidad: this.cantidad,
        };
        this.addToCartProduct(newProduct);
        this.loading = false;
        this.resultado1 = true;
      } catch (error) {
        this.resultado2 = true;
      }
    },
  },
  computed: {
    DescripcionTruncado() {
      const limite = 45;
      if (this.item.descripcion.length > limite) {
        return this.item.descripcion.substring(0, limite) + '...';
      } else {
        return this.item.descripcion;
      }
    },
    CategoriaTruncado() {
      const limite = 21;
      if (this.item.clasificacion.length > limite) {
        return this.item.clasificacion.substring(0, limite) + '...';
      } else {
        return this.item.clasificacion;
      }
    },
  },
  watch: {
    loading(val) {
      if (!val) return;

      setTimeout(() => (this.loading = false), 3000);
    },
  },
};
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.9;
  position: absolute;
  width: 100%;
}
.quantity-controls {
  display: flex;
  align-items: center;
  justify-content: center; /* Centra los elementos horizontalmente */
}

.quantity-decrease,
.quantity-increase {
  background-color: #007bff;
  border: none;
  color: white;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.quantity-input {
  text-align: center;
  margin: 0 10px;
  width: 40px;
}
.v-card-actions {
  width: 100%; /* Asegura que ocupe el ancho completo */
  display: flex;
  justify-content: center; /* Centra el contenido horizontalmente */
}
</style>
